import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BaseTranslateModule } from '@nx-ahs/base-translate';
import { PageTitleFocusDirective } from '@nx-ahs/shared/directives';

import { CreateNewMessageComponent } from './components/create-new-message/create-new-message.component';
import { ConversationCloseWarningComponent } from './components/conversation-close-warning/conversation-close-warning.component';
import { MessagePanelComponent } from './components/message-panel/message-panel.component';
import { SecureMessagingComponent } from './pages/secure-messaging/secure-messaging.component';
import { ChatPanelComponent } from './components/chat-panel/chat-panel.component';

@NgModule({
	declarations: [
		CreateNewMessageComponent,
		ConversationCloseWarningComponent,
		MessagePanelComponent,
		SecureMessagingComponent,
		ChatPanelComponent
	],
	imports: [
		CommonModule,
		BaseTranslateModule,
		FontAwesomeModule,
		ReactiveFormsModule,
		FormsModule,
		MatButtonModule,
		MatCardModule,
		MatCheckboxModule,
		MatDialogModule,
		MatDividerModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatMenuModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		MatRadioModule,
		MatSelectModule,
		MatSidenavModule,
		MatSlideToggleModule,
		MatTabsModule,
		MatTooltipModule,
		NgxMaskDirective,
		PageTitleFocusDirective
	],
	providers: [provideNgxMask()],
	exports: [
		SecureMessagingComponent,
		CreateNewMessageComponent,
		ConversationCloseWarningComponent,
		MessagePanelComponent
	]
})
export class SecureMessageModule {}
